import type { QuoteState, Tariff } from './Quote.types';
import { defineStore } from 'pinia';
import { computed, reactive, watch } from 'vue';
import { useStateUpdate } from '@/shared/lib/pinia/useStateUpdate';
import { ProductCode, TariffType } from './Quote.types';

const storeKey = 'QuoteStore';

function defaultState(): QuoteState {
  return {
    promoCode: '',
    quoteId: '',
    tariff: null,
    tariffType: null,
    price: null,
    deductibleValue: null,
    policyStartDate: null,
    productCode: null,
    productBonus: null,
  };
}

export const useQuoteStore = defineStore(storeKey, () => {
  const state = reactive<QuoteState>(defaultState());
  const $update = useStateUpdate<QuoteState>(state);

  const isGlmTariff = computed(() => state.tariff?.isGlmTariff ?? false);
  const isComprehensiveTariff = computed(() => state.tariffType === TariffType.COMPREHENSIVE);
  const isTplTariff = computed(() => state.tariffType === TariffType.TPL);

  watch(() => state.tariff, (newValue: Tariff | null) => {
    if (newValue) {
      state.tariffType = newValue.type;
      state.productCode = state.tariffType === TariffType.TPL ? ProductCode.TPL : ProductCode.COMPREHENSIVE;
    }
  });

  const reset = () => {
    Object.assign(state, defaultState());
  };

  const priceProps = computed(() => state.tariff?.prices);

  return {
    state,
    isGlmTariff,
    isComprehensiveTariff,
    isTplTariff,
    $update,
    priceProps,
    reset,
  };
}, { persist: { key: storeKey } });
